import {EditWindowMode} from "../types/editorTypes";
import {tempKeyMoment} from "../types/keyMomentTypes";
import {SUPPORTED_SPORTS} from "../constants/globalConstants";

export const defaultKeyMoment: tempKeyMoment = {
    "id": "",
    "title": "",
    "assignee": "",
    "duration": 0,
    "url": "",
    "rating": 0,
    "frame_rate":null,
    "tags": [],
    "away_score": 0,
    "home_score": 0,
    "play_time": 0,
    "period": "",
    "lead": "",
    "eyebrow": "",
    "rubric": "",
    "cut": {
        "id": "",
        "coordinates": [],
        "mode": EditWindowMode.manual,
        "stream_reference": 0,
        "trim_points": [],
        "landmarks": [],
        "trim_labels": []
    },
    "notes": "",
    "event_id": "",
    "stream_time_start": 0,
    "stream_time_end": 0,
    "thumbnail": null,
    "aspect_ratio": ""
}

export enum KEY_MOMENT_CUT_TYPE{
    COPY = "copy",
    MASTER = "master"
}

export const KEY_MOMENT_REPLAY: Record<SUPPORTED_SPORTS, string[]> = {
    [SUPPORTED_SPORTS.FOOTBALL]: ["GOAL"],
    [SUPPORTED_SPORTS.VOLLEY]: []
}